// import { ReactComponent as SubnetMappingsStatusIcon } from "@/Icons/subnet-mappings-status.svg"

import { BifrostLoader } from "@/Components/elements"
import React from "react"
import { Segment } from "semantic-ui-react"
import SubnetMappingsOverview from "./SubnetMappingsOverview"
import SubnetMappingsTable from "./SubnetMappingsTable"
import { useSubnetMappings } from "./hooks"

const SubnetMappings = ({ directTunnelStatus }, ref) => {
	const { getDirectTunnelSubnetMapping, directTunnelSubnetMapping } = useSubnetMappings(ref)

	return (
		<Segment>
			<BifrostLoader backgroundColor="white" inverted height="40px" minHeight="20px" isLoading={directTunnelSubnetMapping.isFetching}>
				<SubnetMappingsOverview directTunnelData={directTunnelSubnetMapping.data} />
				<SubnetMappingsTable directTunnelData={directTunnelSubnetMapping.data} getDirectTunnelSubnetMapping={getDirectTunnelSubnetMapping} directTunnelStatus={directTunnelStatus} />
			</BifrostLoader>
		</Segment>
	)
}

export default React.forwardRef(SubnetMappings)
